export enum FluidElementType {
  Text = "Text",
  Heading = "Heading",
  Button = "Button",
  Image = "Image",
  AppStoreButton = "AppStoreButton",
  SocialLinks = "SocialLinks",
  Form = "Form",
  Video = "Video",
  Counter = "Counter",
  Embed = "Embed",
  Map = "Map",
}

export enum StickyScrollPosition {
  Top = "top",
  Center = "center",
  Bottom = "bottom",
}

export enum AlignmentDirection {
  Horizontal = "horizontal",
  Vertical = "vertical",
}

export enum DistributionDirection {
  Horizontal = "horizontal",
  Vertical = "vertical",
}

export enum AlignmentValue {
  Start = "start",
  Center = "center",
  End = "end",
}

export enum PaddingValue {
  None = 0,
  Small = 20,
  Medium = 40,
  Large = 60,
}

export enum BackgroundType {
  Color = "Color",
  Image = "Image",
  Video = "Video",
}

export enum ColorType {
  Theme = "Theme",
  Custom = "Custom",
  Gradient = "Gradient",
}

// Not used
// export enum ImageObjectFit {
//   "None" = "None",
//   "Fill" = "Fill",
//   "Cover" = "Cover",
//   "Contain" = "Contain",
// }

export enum BackgroundPosition {
  LeftTop = "left top",
  CenterTop = "center top",
  RightTop = "right top",
  LeftCenter = "left center",
  CenterCenter = "center center",
  RightCenter = "right center",
  LeftBottom = "left bottom",
  CenterBottom = "center bottom",
  RightBottom = "right bottom",
}

export enum BackgroundRepeat {
  Repeat = "repeat",
  NoRepeat = "no-repeat",
}

export enum BackgroundScrollEffect {
  Fixed = "fixed",
  Scroll = "scroll",
}

export enum ImageSize {
  "Cover" = "cover",
  "Contain" = "contain",
}

export enum ThemeColorClass {
  brand = "brand",
  secondary = "secondary",
  base = "base",
  accent = "accent",
}

export enum ThemeColor {
  brand1 = "brand1",
  brand2 = "brand2",
  brand3 = "brand3",
  brand4 = "brand4",
  secondary1 = "secondary1",
  secondary2 = "secondary2",
  secondary3 = "secondary3",
  secondary4 = "secondary4",
  base1 = "base1",
  base2 = "base2",
  base3 = "base3",
  base4 = "base4",
  base5 = "base5",
  accent1 = "accent1",
  accent2 = "accent2",
  transparent = "transparent",
}

export enum ColorValue {
  brand1 = "--theme-color-brand1",
  brand2 = "--theme-color-brand2",
  brand3 = "--theme-color-brand3",
  brand4 = "--theme-color-brand4",
  secondary1 = "--theme-color-secondary1",
  secondary2 = "--theme-color-secondary2",
  secondary3 = "--theme-color-secondary3",
  secondary4 = "--theme-color-secondary4",
  base1 = "--theme-color-base1",
  base2 = "--theme-color-base2",
  base3 = "--theme-color-base3",
  base4 = "--theme-color-base4",
  base5 = "--theme-color-base5",
  accent1 = "--theme-color-accent1",
  accent2 = "--theme-color-accent2",
  transparent = "--theme-transparent-color",
}

export enum Breakpoint {
  Mobile = "mobile",
  Tablet = "tablet",
  Desktop = "desktop",
}

export enum Side {
  Top = "top",
  Right = "right",
  Bottom = "bottom",
  Left = "left",
}

export enum GuideLinesType {
  Grid = "grid",
  Element = "element",
}
